if (!customElements.get('sanalio-immersive-hero')) {
  customElements.define('sanalio-immersive-hero', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.addEventListener('click', event => {
        const step = event.target.closest('[data-step]');
        if (step && this.contains(step)) this.selectStep(step);
        const opener = event.target.closest('[data-open-dialog]');
        if (opener && opener.closest('sanalio-immersive-hero') === this) {
          const dialog = this.querySelector('#' + CSS.escape(opener.getAttribute('aria-controls')));
          if (!dialog || dialog.open) return;
          this.opener = opener;
          dialog.showModal();
          opener.setAttribute('aria-expanded', 'true');
          if (!matchMedia('(prefers-reduced-motion: reduce)').matches) dialog.animate([{ opacity: 0.5, translate: '0 12px' }, { opacity: 1, translate: '0 0' }], { duration: 200, easing: 'ease-out' });
          dialog.querySelector('[data-close-dialog]')?.focus({ preventScroll: true });
        }
        const closer = event.target.closest('[data-close-dialog]');
        if (closer && this.contains(closer)) closer.closest('dialog').close();
      }, options);
      this.querySelectorAll('dialog').forEach(dialog => {
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const bounds = dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
        }, options);
        dialog.addEventListener('close', () => {
          const opener = this.querySelector('[aria-controls="' + dialog.id + '"]');
          opener?.setAttribute('aria-expanded', 'false');
          if (opener?.isConnected) opener.focus({ preventScroll: true });
        }, options);
      });
      this.addEventListener('shopify:block:select', event => {
        const selectedDialog = event.target.closest('dialog') || (event.target === this ? this.querySelector('dialog') : null);
        if (selectedDialog && !selectedDialog.open) selectedDialog.showModal();
        const step = this.querySelector('[data-block-id="' + CSS.escape(event.detail.blockId) + '"]');
        if (step) this.selectStep(step);
      }, options);
      this.observer = new ResizeObserver(() => this.positionLabels());
      this.observer.observe(this);
      this.positionLabels();
    }
    selectStep(step) {
      this.querySelectorAll('[data-step]').forEach(button => button.setAttribute('aria-pressed', String(button === step)));
      this.querySelectorAll('[data-step-panel]').forEach(panel => {
        panel.hidden = panel.dataset.stepPanel !== step.dataset.step;
        if (!panel.hidden && !matchMedia('(prefers-reduced-motion: reduce)').matches) panel.animate([{ opacity: 0.3, transform: 'translateY(4px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 180, easing: 'ease-out' });
      });
    }
    positionLabels() {
      const area = this.querySelector('.snh-points');
      if (!area) return;
      const frame = area.getBoundingClientRect();
      this.querySelectorAll('.snh-point-label').forEach(label => {
        label.style.setProperty('--snh-label-offset', '0px');
        const box = label.getBoundingClientRect();
        const shift = Math.max(0, frame.left + 8 - box.left) - Math.max(0, box.right - frame.right + 8);
        label.style.setProperty('--snh-label-offset', shift + 'px');
      });
    }
    disconnectedCallback() {
      this.querySelectorAll('dialog[open]').forEach(dialog => dialog.close());
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = null;
    }
  });
}



if (!customElements.get('sanalio-hero-content')) {
  customElements.define('sanalio-hero-content', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.placements = new Map();
      this.viewport = matchMedia('(max-width:899px)');
      this.queueLayout = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.layout());
      };
      this.viewport.addEventListener('change', this.queueLayout, { signal: this.controller.signal });
      this.observer = new MutationObserver(this.queueLayout);
      this.observer.observe(this.closest('.snh-grid'), { childList: true, subtree: true });
      this.queueLayout();
    }
    place(node, parent, next = null) {
      if (node.parentNode !== parent || node.nextSibling !== next) parent.insertBefore(node, next);
    }
    remember(node) {
      if (!this.placements.has(node)) {
        const marker = document.createComment('hero-block-position');
        node.before(marker);
        this.placements.set(node, marker);
      }
      return this.placements.get(node);
    }
    layout() {
      const hero = this.closest('.snh'), heading = hero?.querySelector('.snh-heading');
      const blocks = this.querySelector('.snh-native-blocks');
      if (!blocks || !heading) return;
      this.observer.disconnect();
      const mobile = this.viewport.matches;
      if (hero.classList.contains('snh--home-compact')) {
        const logo = hero.querySelector('.snl-logo-photo');
        if (logo) {
          const marker = this.remember(logo);
          if (mobile) this.place(logo, heading, heading.firstChild === logo ? logo.nextSibling : heading.firstChild);
          else if (marker.isConnected) this.place(logo, marker.parentNode, marker.nextSibling === logo ? logo.nextSibling : marker.nextSibling);
        }
      }
      hero.querySelectorAll('.snh-native-blocks > .snl-reviews, .snh-heading > .snl-reviews, .snh-content > .snl-reviews').forEach(review => {
        const position = review.dataset[mobile ? 'heroPositionMobile' : 'heroPositionDesktop'] || 'native';
        const marker = position === 'native' ? this.placements.get(review) : this.remember(review);
        const buttons = blocks.querySelector(':scope > .snl-actions');
        if (position === 'before_title') {
          this.place(review, heading, heading.querySelector('.snh-eyebrow, .snh-title'));
        } else if (position === 'before_intro') {
          this.place(review, this, this.querySelector('.snh-intro, .snh-note, .snh-native-blocks'));
        } else if (position === 'before_buttons' && buttons) {
          this.place(review, blocks, buttons);
        } else if (position === 'after_buttons' && buttons) {
          this.place(review, blocks, buttons.nextSibling === review ? review.nextSibling : buttons.nextSibling);
        } else if (marker?.isConnected) {
          this.place(review, marker.parentNode, marker.nextSibling === review ? review.nextSibling : marker.nextSibling);
          if (position === 'native') { marker.remove(); this.placements.delete(review); }
        }
      });
      this.observer.observe(hero.querySelector('.snh-grid'), { childList: true, subtree: true });
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      this.controller?.abort();
      this.controller = null;
    }
  });
}
